module.exports = __webpack_public_path__ + "media/images/logo/Logo(V)_Dark-d02eff1f8882382e5255e6a8d327a7fe.png";